import { CgSpinnerTwoAlt } from "react-icons/cg";

import styles from "./myLoader.module.css";

export function MyBigLoader() {
  return (
    <div className={styles.mySpinnerContainer}>
      <CgSpinnerTwoAlt size={180} className={styles.mySpinner} />
      <CgSpinnerTwoAlt size={130} className={styles.mySpinnerRev} />
      <CgSpinnerTwoAlt size={95} className={styles.mySpinner} />
    </div>
  );
}

export function MyLittleLoader() {
  return <CgSpinnerTwoAlt size={30} className={styles.mySpinnerSmall} />;
}
